unit UAnalysis;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, WEBLib.Grids, Vcl.Controls, WEBLib.WebCtrls,
  XData.Web.Client, Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TKundenObject = class(TObject)
  private
    FID: Integer;
    procedure SetID(const Value: Integer);
  public
    constructor Create(aID : Integer); overload;
    destructor Destroy; override;
    property ID : Integer read FID write SetID;
  end;

  TfrmAnalysis = class(TForm)
    divAnalysisContainer: THTMLDiv;
    divAnalysisMainContainer: THTMLDiv;
    tblAnalysis: TTableControl;
    cbCustomer: TComboBox;
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure cbCustomerChange(Sender: TObject);
  private
    [async] procedure FillForm; async;
    [async] procedure GetLaundry; async;
    [async] procedure FillCombo; async;
    procedure ShowHeaders;
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  frmAnalysis: TfrmAnalysis;

implementation

uses
  UDatamodule, UHelper, UJSHelper, UResources, UErrorHandling;

{$R *.dfm}

procedure TfrmAnalysis.cbCustomerChange(Sender: TObject);
begin
  GetLaundry;
end;


procedure TfrmAnalysis.FillCombo;
var
  LResponse: TXDataClientResponse;
  KundenArray : TJSArray;
  JSObject : TJsObject;
  Kunde : TJSObject;
  I: Integer;
  KO : TKundenObject;
begin
  cbCustomer.Items.Clear;

  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IKunden.GetAktiveKunden',
        [])
      );

    if LResponse.StatusCode = 200 then
    begin
      THelper.DebugODS('Received AktiveKunden');
      JSObject := LResponse.ResultAsObject;
      KundenArray := TJSArray(JSObject['value']);

      for I := 0 to KundenArray.Length - 1 do
      begin
        Kunde := TJsObject(KundenArray.Elements[I]);
        KO := TKundenObject.Create(Integer(Kunde.Properties['Nr']));
        cbCustomer.Items.AddPair(String(Kunde.Properties['Anzeigename']), String(Kunde.Properties['ID']));
      end;

      if (cbCustomer.Items.Count > 0) then
      begin
        cbCustomer.ItemIndex := 0;
      end;
    end
    else
    begin
      MessageDlg('Active customer list not received. Status: ' + IntToStr(LResponse.StatusCode), mtInformation, [mbOk]);
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmAnalysis.FillForm;
begin
  await(FillCombo);
  await(GetLaundry);
end;


procedure TfrmAnalysis.GetLaundry;
var
  LResponse: TXDataClientResponse;
  LaundryArray : TJSArray;
  JSObject : TJsObject;
  Laundry : TJSObject;
  I: Integer;
  Idx : Integer;
  KIdx : Integer;
  KundenNr : Integer;
begin
  try
    KIdx := cbCustomer.ItemIndex;

    if (KIdx >= 0) then
    begin
      KundenNr := StrToInt(cbCustomer.Values[KIdx]);

      LResponse :=
        await(
          TXDataClientResponse,
          UDM.XDataWebClient.RawInvokeAsync('ILaundry.GetReportLaundryByHK',
          [KundenNr])
        );

      if LResponse.StatusCode = 200 then
      begin
        THelper.DebugODS('Received ReportLaundry');
        JSObject := LResponse.ResultAsObject;
        LaundryArray := TJSArray(JSObject['value']);

        tblAnalysis.RowCount := LaundryArray.Length + 1;

        Idx := 0;

        for I := 0 to LaundryArray.Length - 1 do
        begin
          Idx := I + 1;

          Laundry := TJsObject(LaundryArray.Elements[I]);

  //        if Integer(Laundry.Properties['Gemeldet']) = 1 then
  //        begin
  //          tblLogitic.RowClassName[Idx] := 'wcCLLogisticRowGreen'
  //        end
  //        else
  //        begin
  //          tblLogitic.RowClassName[Idx] := 'wcCLLogisticRowRed'
  //        end;

          tblAnalysis.Cells[0, Idx] := String(Laundry.Properties['AuftragID']);
          tblAnalysis.Cells[1, Idx] := String(Laundry.Properties['Date']);
          tblAnalysis.Cells[2, Idx] := String(Laundry.Properties['Time']);
          tblAnalysis.Cells[3, Idx] := String(Laundry.Properties['KundeAnzeigename']);
          tblAnalysis.Cells[4, Idx] := String(Laundry.Properties['AnzahlSchmutzwaesche']) + ' / ' + String(Laundry.Properties['Dirty']);
          tblAnalysis.Cells[5, Idx] := String(Laundry.Properties['EmptyNeeded']);
          tblAnalysis.Cells[6, Idx] := String(Laundry.Properties['AnzahlLeercontainer']) + ' / ' + String(Laundry.Properties['EmptyBack']);
          tblAnalysis.Cells[7, Idx] := String(Laundry.Properties['Comment']);
        end;

      end
      else
      begin
        MessageDlg('Laundry list not received. Status: ' + IntToStr(LResponse.StatusCode), mtInformation, [mbOk]);
      end;
    end
    else
    begin
      MessageDlg('Ausgewählter Name nicht gefunden.', mtInformation, [mbOk]);
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmAnalysis.ShowHeaders;
begin
  tblAnalysis.Cells[0,0] := 'Nr';
  tblAnalysis.Cells[1,0] := 'Lieferdatum';
  tblAnalysis.Cells[2,0] := 'Uhrzeit';
  tblAnalysis.Cells[3,0] := 'Kunde';
  tblAnalysis.Cells[4,0] := 'Schmutzwäschecontainer<br>(Gescannt / Gemeldet)';
  tblAnalysis.Cells[5,0] := 'Leercontainer zum Kunden liefern';
  tblAnalysis.Cells[6,0] := 'Leercontainer vom Kunden abholen<br>(Gescannt / Gemeldet)';
  tblAnalysis.Cells[7,0] := 'Kommentar';

  tblAnalysis.RowCount := 1;
end;


procedure TfrmAnalysis.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;


procedure TfrmAnalysis.WebFormCreate(Sender: TObject);
begin
  ShowHeaders;
end;


procedure TfrmAnalysis.WebFormShow(Sender: TObject);
begin
{$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.AnalysisInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
    pas.UJSHelper.THTMLComponents.Translations();
  end;
{$ENDIF}
  FillForm;
end;

{ TKundenObject }


constructor TKundenObject.Create(aID: Integer);
begin
  inherited Create;

  FID := aID;
end;


destructor TKundenObject.Destroy;
begin

  inherited;
end;


procedure TKundenObject.SetID(const Value: Integer);
begin
  FID := Value;
end;


procedure TfrmAnalysis.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divAnalysisContainer := THTMLDiv.Create('wcIDAnalysisContainer');
  divAnalysisMainContainer := THTMLDiv.Create('wcIDAnalysisMainContainer');
  tblAnalysis := TTableControl.Create('wcIDAnalysisTbl');
  cbCustomer := TComboBox.Create(Self);

  divAnalysisContainer.BeforeLoadDFMValues;
  divAnalysisMainContainer.BeforeLoadDFMValues;
  tblAnalysis.BeforeLoadDFMValues;
  cbCustomer.BeforeLoadDFMValues;
  try
    Name := 'frmAnalysis';
    Width := 1098;
    Height := 866;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divAnalysisContainer.SetParentComponent(Self);
    divAnalysisContainer.Name := 'divAnalysisContainer';
    divAnalysisContainer.Left := 0;
    divAnalysisContainer.Top := 0;
    divAnalysisContainer.Width := 1098;
    divAnalysisContainer.Height := 866;
    divAnalysisContainer.HeightStyle := ssAuto;
    divAnalysisContainer.WidthStyle := ssAuto;
    divAnalysisContainer.Align := alClient;
    divAnalysisContainer.ChildOrder := 2;
    divAnalysisContainer.ElementPosition := epIgnore;
    divAnalysisContainer.ElementFont := efCSS;
    divAnalysisContainer.Role := '';
    divAnalysisMainContainer.SetParentComponent(divAnalysisContainer);
    divAnalysisMainContainer.Name := 'divAnalysisMainContainer';
    divAnalysisMainContainer.Left := 0;
    divAnalysisMainContainer.Top := 0;
    divAnalysisMainContainer.Width := 1098;
    divAnalysisMainContainer.Height := 866;
    divAnalysisMainContainer.ElementClassName := 'wcCLMainContainer Container';
    divAnalysisMainContainer.HeightStyle := ssAuto;
    divAnalysisMainContainer.WidthStyle := ssAuto;
    divAnalysisMainContainer.Align := alClient;
    divAnalysisMainContainer.ElementPosition := epIgnore;
    divAnalysisMainContainer.ElementFont := efCSS;
    divAnalysisMainContainer.Role := '';
    tblAnalysis.SetParentComponent(divAnalysisMainContainer);
    tblAnalysis.Name := 'tblAnalysis';
    tblAnalysis.Left := 125;
    tblAnalysis.Top := 256;
    tblAnalysis.Width := 705;
    tblAnalysis.Height := 363;
    tblAnalysis.ElementClassName := 'display wcCLTableAnalysis';
    tblAnalysis.HeightStyle := ssAuto;
    tblAnalysis.WidthStyle := ssAuto;
    tblAnalysis.BorderColor := clSilver;
    tblAnalysis.ChildOrder := 1;
    tblAnalysis.ElementFont := efCSS;
    tblAnalysis.ElementHeaderClassName := 'thead-light';
    tblAnalysis.ElementPosition := epIgnore;
    tblAnalysis.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    tblAnalysis.Font.Charset := DEFAULT_CHARSET;
    tblAnalysis.Font.Color := clWindowText;
    tblAnalysis.Font.Height := -16;
    tblAnalysis.Font.Name := 'Tahoma';
    tblAnalysis.Font.Style := [];
    tblAnalysis.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    tblAnalysis.Footer.ButtonElementClassName := 'btn btn-light';
    tblAnalysis.Footer.DropDownElementClassName := 'form-control';
    tblAnalysis.Footer.InputElementClassName := 'form-control';
    tblAnalysis.Footer.LinkActiveElementClassName := 'link-primary';
    tblAnalysis.Footer.LinkElementClassName := 'link-secondary';
    tblAnalysis.Footer.ListElementClassName := 'pagination';
    tblAnalysis.Footer.ListItemElementClassName := 'page-item';
    tblAnalysis.Footer.ListLinkElementClassName := 'page-link';
    tblAnalysis.Header.ButtonActiveElementClassName := 'btn btn-primary';
    tblAnalysis.Header.ButtonElementClassName := 'btn btn-light';
    tblAnalysis.Header.DropDownElementClassName := 'form-control';
    tblAnalysis.Header.InputElementClassName := 'form-control';
    tblAnalysis.Header.LinkActiveElementClassName := 'link-primary';
    tblAnalysis.Header.LinkElementClassName := 'link-secondary';
    tblAnalysis.Header.ListElementClassName := 'pagination';
    tblAnalysis.Header.ListItemElementClassName := 'page-item';
    tblAnalysis.Header.ListLinkElementClassName := 'page-link';
    tblAnalysis.ParentFont := False;
    tblAnalysis.ColCount := 8;
    cbCustomer.SetParentComponent(divAnalysisMainContainer);
    cbCustomer.Name := 'cbCustomer';
    cbCustomer.Left := 125;
    cbCustomer.Top := 184;
    cbCustomer.Width := 145;
    cbCustomer.Height := 26;
    cbCustomer.ElementClassName := 'form-select';
    cbCustomer.ElementPosition := epIgnore;
    cbCustomer.HeightStyle := ssAuto;
    cbCustomer.HeightPercent := 100.000000000000000000;
    cbCustomer.WidthPercent := 100.000000000000000000;
    SetEvent(cbCustomer, Self, 'OnChange', 'cbCustomerChange');
    cbCustomer.ItemIndex := -1;
  finally
    divAnalysisContainer.AfterLoadDFMValues;
    divAnalysisMainContainer.AfterLoadDFMValues;
    tblAnalysis.AfterLoadDFMValues;
    cbCustomer.AfterLoadDFMValues;
  end;
end;

initialization
  RegisterClass(TfrmAnalysis);

end.